import nl from "@/i18n/nl.json";
import de from "@/i18n/de.json";
import en from "@/i18n/en.json";
import fr from "@/i18n/fr.json";
import pl from "@/i18n/pl.json";

const translations = { nl, de, en, fr, pl };

export const SUPPORTED_LOCALES = [
  { code: "nl", label: "NL", flag: "\u{1F1F3}\u{1F1F1}" },
  { code: "de", label: "DE", flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "en", label: "EN", flag: "\u{1F1EC}\u{1F1E7}" },
  { code: "fr", label: "FR", flag: "\u{1F1EB}\u{1F1F7}" },
  { code: "pl", label: "PL", flag: "\u{1F1F5}\u{1F1F1}" },
];

/** Translator for a locale: returns { t, locale } where t(key, fallback?, vars?) looks up the i18n dict, falls back to the key, and substitutes {placeholders}. Defaults to nl. */
export function getTranslations(locale = "nl") {
  const dict = translations[locale] || translations.nl;

  // Backwards-compatible signatures:
  //   t("key")                         → raw value (or key if missing)
  //   t("key", "fallback")             → fallback string if key missing
  //   t("key", { adults: 2 })          → substitute {adults} placeholders
  //   t("key", "fallback", { ... })    → both
  function t(key, fallbackOrVars, maybeVars) {
    let fallback;
    let vars;
    if (typeof fallbackOrVars === "string") {
      fallback = fallbackOrVars;
      vars = maybeVars;
    } else {
      vars = fallbackOrVars;
    }
    const raw = dict[key] ?? fallback ?? key;
    if (!vars || typeof raw !== "string") return raw;
    return raw.replace(/\{(\w+)\}/g, (_, k) =>
      Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k]) : `{${k}}`,
    );
  }

  return { t, locale };
}

export function detectLocale(hostname) {
  if (!hostname) return "nl";
  if (hostname.includes("favotrip.de") || hostname.startsWith("de.")) return "de";
  if (hostname.startsWith("en.")) return "en";
  if (hostname.includes("favotrip.fr") || hostname.startsWith("fr.")) return "fr";
  if (hostname.includes("favotrip.pl") || hostname.startsWith("pl.")) return "pl";
  return "nl";
}
